import Text from '../../../utils/text'
import {CopyIcon} from '../../../icons'
import './index.scss'
import {colors} from '../../../utils/colors'

const CopyButton = ({text}) => {
    return (
        <span className="copy-button" onClick={() => Text.copyText(text)}>
            <CopyIcon stroke={colors.colorWhite}/>
        </span>
    )
}

export default CopyButton
